import React from 'react';
import Card from './Card';
import { List } from './styles';

const CareList = ({ careCenters, ...rest }) => (
  <List
    {...rest}>
    {careCenters.map(
      ({ correlationId, name, city, attributes, error }) => (
        <Card
          key={correlationId}
          name={name}
          city={city}
          error={error}
          status={attributes?.status}
        />
      )
    )}
  </List>
);

export default CareList;
